import React from 'react'
import { Banner } from '@zuto/atoms/src/Mui/Banner/Banner'
import { Box, Grid, Typography } from '@mui/material'
import TrustBox from '../../../TrustPilotHeader/TrustBox'
import { RecievedApplicationText } from './ReceivedApplicationText'
import { WhyCustomersLoveZuto } from './WhyCustomersLoveZuto'
import Button from '@zuto/atoms/src/Mui/Button/Button'
import { ArrowRight } from '@zuto/icons'
import { KnownSource } from '../../../../types/Source'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'
import { styled } from '@mui/material/styles'
import { fireReactGAEvent } from '../../../Questions/utils'
import { LenderDetails } from '../../ApplicationFormContext'
import LenderDetailsMessaging from './LenderDetailsMessaging'
import { FooterNavigationLinks } from '../../../../GlobalVariables/Navigation'

type FormlessJourneyProps = {
  redirectUrl: string | undefined
  source: KnownSource
  experimentName: string
  lenderDetails?: LenderDetails
  shouldShowConfetti?: boolean
}

const StyledLink = styled('a')(() => ({
  color: 'inherit',
  textDecoration: 'none'
}))

export const FormlessJourneyWithContinueCta = ({
  redirectUrl,
  source,
  experimentName,
  lenderDetails
}: FormlessJourneyProps) => {
  const handleClick = () => {
    fireReactGAEvent({
      category: 'Application Form',
      action: 'FormlessContinueCtaClicked',
      label: experimentName,
      source
    })
    if (redirectUrl) {
      window.location.replace(redirectUrl)
    }
  }

  const shouldShowWhereApplicationIsFrom = source === 'carmoola'

  return (
    <Box sx={{ maxWidth: "500px", margin: "0 auto" }} data-testid={`${source}-interstitial`}>
      <Banner bannerText="Welcome to Zuto" />

      <Grid
        mt={4}
        mb={4}
        style={{
          textAlign: 'center',
          borderBottom: '1px solid #eee',
          paddingBottom: '12px'
        }}
      >
        <TrustBox />
      </Grid>

      {!shouldShowWhereApplicationIsFrom && (
        <LenderDetailsMessaging lenderDetails={lenderDetails} />
      )}

      <RecievedApplicationText
        source={source}
        shouldShowWhereApplicationIsFrom={shouldShowWhereApplicationIsFrom}
      />

      <WhyCustomersLoveZuto source={source} />

      <Box pl={5} pr={5}>
        <Button
          endSvgIcon={ArrowRight}
          data-testid="continue-to-account-button"
          onClick={handleClick}
        >
          Continue
        </Button>
        <Box display="flex" justifyContent="space-between" mt={8} mb={8}>
          <Typography variant="bodySmall" color={tonalPalettes.tertiary[40]}>
            <StyledLink
              href={FooterNavigationLinks.privacyPolicy}
              target="_blank"
            >
              Privacy Policy
            </StyledLink>
          </Typography>
          <Typography variant="bodySmall" color={tonalPalettes.tertiary[40]}>
            <StyledLink
              href={FooterNavigationLinks.termsAndConditions}
              target="_blank"
            >
              Terms of Service
            </StyledLink>
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
